import styled from "styled-components";
import {VouchersSwiperTitleDefaultBox} from "./vouchers-swiper-title.default.box";

export const VouchersSwiperTitleSIBox = styled(VouchersSwiperTitleDefaultBox)`
    ${({theme}) => theme.font.presets.thin}
`;
